import React, { useCallback, useEffect, useState } from "react";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import { FiEdit } from "react-icons/fi";
import Label from "../../Form/Label";
import Heading from "../../Form/Heading";
import { MdOutlineSettings } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import GLPagesService from "../../Services/GLPagesService";
import SpinWheelService from "../../Services/SpinWheelService";
import GLpageTemplatePopup from "./GLpageTemplatePopup";
import { ToastContainer } from "react-toastify";
import {
  showErrorToast,
  showInfoToast,
  showSuccessToast,
} from "../../Constant/Notification";
import Select from "react-select";
import AmenitiesService from "../../Services/AmenitiesService";
import CustomHeading from "../../common/CustomHeading";
import HeaderAndHero from "./GLpagesStep/HeaderAndHero";
import { icons } from "lucide-react";
import { getIcons } from "../../Constant/Constant";
import FeaturesSection from "./GLpagesStep/FeaturesSection";
import PropertyOverview from "./GLpagesStep/PropertyOverview";
import FormSection from "./GLpagesStep/FormSection";
import MoreImages from "./GLpagesStep/MoreImages";
import ContactUs from "./GLpagesStep/ContactUs";
import CustomerTestimonial from "./GLpagesStep/CustomerTestimonial";
import VideoSection from "./GLpagesStep/VideoSection";
import FooterSection from "./GLpagesStep/FooterSection";
import CustomStepProgress from "../../common/CustomStepProgress";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { glPageUrl } from "../../../config/clientsConfig";
const GLpageCreatingSection = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { GLPageId } = location.state || {};
  const [openPopup, setOpenPopup] = useState(false);

  const icons = getIcons();

  const [videoWarning, setVideoWarning] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [loadingState, setLoadingState] = useState({
    logo: false,
    bannerImages: false,
    section1: false,
    section2: false,
    section3: false,
    section4: false,
    section5: false,
    sectionForm: false,
    sectionMore: false,
  });

  const [basicAmenities, setBasicAmenities] = useState([]);
  const [selectedBasic, setSelectedBasic] = useState([]);
  const [featuresAmenities, setFeaturesAmenities] = useState([]);
  const [selectedFeatures, setSelectedFeatures] = useState([]);
  const [nearbyAmenities, setNearbyAmenities] = useState([]);
  const [selectedNearby, setSelectedNearby] = useState([]);

  const [loading , setLoading] = useState(false)

  const {
    selectedStyleDetails,
    selectedProperty,
    selectedPropertyId,
    selectedPropertyTypeId,
    selectedPropertyTypeName,
  } = location.state || {};

  const { isEditMode } = location.state || {};

  const [formData, setFormData] = useState({
    pageStyle: {
      label: selectedStyleDetails?.label || "",
      color: selectedStyleDetails?.color || "",
    },
    propertyName: selectedProperty || "",
    propertyId: selectedPropertyId || "",
    propertyType: selectedPropertyTypeId || "",
    propertyTypeName: selectedPropertyTypeName || "",
    header: { phoneNumber: "", logo: null },
    hero: {
      bannerImages: [],
      title: "",
      description: "",
    },
    featuresSection: {
      enable: false,
      title: "",
      section1: { image: "", title: "" },
      section2: { image: "", title: "" },
      section3: { image: "", title: "" },
      section4: { image: "", title: "" },
      section5: { image: "", title: "" },
    },
    formData: {
      enable: false,
      image: "",
      title: "",
      description: "",
      field1: { name: "", enable: false },
      field2: { name: "", enable: false },
      field3: { name: "", enable: false },
      field4: { name: "", enable: false },
    },
    gallery: {
      enable: false,
      title: "",
      images: [],
    },
    contactUs: {
      enable: false,
      title: "",
      map: {
        location: "",
        coordinates: { lat: "", lng: "" },
        address: "",
        email: "",
        phoneNumber: "",
      },
    },
    customerTestimonial: {
      enable: false,
      title: "",
      customer1: { name: "", feedback: "" },
      customer2: { name: "", feedback: "" },
      customer3: { name: "", feedback: "" },
    },
    videoSection: {
      enable: false,
      title: "",
      description: "",
      videoLink: "",
    },
    footer: {
      description: "",
    },
    propertyOverview: {
      enable: false,
      name: selectedProperty || "",
      description: "",
      overallArea: 0,
      availableUnits: 0,
      averagePrice: { min: 0, max: 0 },
      averageUnitSqft: { min: 0, max: 0 },
      launchDate: "",
      constructionType: "",
      configuration: "",
      possessionStatus: "",
      basicAmenities: [],
      featuredAmenities: [],
      nearbyAmenities: [],
    },
  });

  const imageSizeGuide = {
    "Luxurious and Rich": {
      logo: "150 x 60px",
      heroBannerSize: "430 x 820px",
      featuresSectionImage: "440 x 490px",
      formImage: "1440 x 620px",
      moreImages: "560 x 300px",
    },
    "Urban and Modern": {
      logo: "150 x 60px",
      heroBannerSize: "1360 x 700px",
      featuresSectionImage: "440 x 260px",
      formImage: "670 x 600px",
      moreImages: "490 x 220px",
    },
  };

  const imageSampleGuide = {
    "Luxurious and Rich": {
      headerAndHero: icons.tOneImage1,
      fiveFeature: icons.tOneImage2,
      propertyOverview: icons.tOneImage3,
      form: icons.tOneImage4,
      moreImages: icons.tOneImage5,
      contactUs: icons.tOneImage6,
      customerTestimonial: icons.tOneImage7,
      video: icons.tOneImage8,
      footer: icons.tOneImage9,
    },
    "Urban and Modern": {
      headerAndHero: icons.tTowImage1,
      fiveFeature: icons.tTowImage2,
      propertyOverview: icons.tTowImage3,
      form: icons.tTowImage4,
      moreImages: icons.tTowImage5,
      contactUs: icons.tTowImage6,
      customerTestimonial: icons.tTowImage7,
      video: icons.tTowImage8,
      footer: icons.tTowImage9,
    },
  };
  const steps = [
    { id: 1, label: "Header & Hero" },
    { id: 2, label: "5 Feature" },
    { id: 3, label: "Property Overview" },
    { id: 4, label: "Form" },
    { id: 5, label: "More Images" },
    { id: 6, label: "Contact Us" },
    { id: 7, label: "Customer Testimonial" },
    { id: 8, label: "Video" },
    { id: 9, label: "Footer" },
  ];

  const [currentStep, setCurrentStep] = useState(1);
  const selectedLabel = selectedStyleDetails?.label || formData.pageStyle.label ;
  const sizeGuide = imageSizeGuide[selectedLabel];
  const sampleGuide = imageSampleGuide[selectedLabel];



  const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    const [month, day, year] = dateString.split("/");
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  };

  const addSelectAllOption = (options) => {
    return [
      { value: "all", label: "Select All" },
      ...options.filter((option) => option.value !== "all"),
    ];
  };

  const handleSelectChange = (selected, type) => {
    const allOptions =
      type === "basic"
        ? basicAmenities
        : type === "features"
        ? featuresAmenities
        : nearbyAmenities;

    const isSelectAll = selected?.some((s) => s.value === "all");
    let newSelectedOptions = [];

    if (isSelectAll) {
      newSelectedOptions = allOptions.filter(
        (option) => option.value !== "all"
      );
    } else {
      newSelectedOptions = (selected || []).filter(
        (option) => option.value !== "all"
      );
    }

    if (type === "basic") {
      setSelectedBasic(newSelectedOptions);
      setFormData({
        ...formData,
        propertyOverview: {
          ...formData.propertyOverview,
          basicAmenities: newSelectedOptions.map((option) => ({
            id: option.value,
            name: option.label,
          })),
        },
      });
    } else if (type === "features") {
      setSelectedFeatures(newSelectedOptions);
      setFormData({
        ...formData,
        propertyOverview: {
          ...formData.propertyOverview,
          featuredAmenities: newSelectedOptions.map((option) => ({
            id: option.value,
            name: option.label,
          })),
        },
      });
    } else {
      setSelectedNearby(newSelectedOptions);
      setFormData({
        ...formData,
        propertyOverview: {
          ...formData.propertyOverview,
          nearbyAmenities: newSelectedOptions.map((option) => ({
            id: option.value,
            name: option.label,
          })),
        },
      });
    }
  };

  const getPropertyOverViewDetails = async () => {
    if (!selectedPropertyId || !selectedPropertyTypeName) return;
    try {
      const response = await GLPagesService.getPropertyOverViewData(
        selectedPropertyId,
        selectedPropertyTypeName
      );
      if (!response.data) {
        showErrorToast("No property overview data found.");
        return;
      }

      const data = response.data;
      console.log("Property overview:", data);

      const basicAmenitiesMapped =
        data.amenities?.[0]?.basicAmenities?.map((item) => ({
          value: item.id,
          label: item.name,
        })) || [];
      const featuredAmenitiesMapped =
        data.amenities?.[0]?.futureAmenities?.map((item) => ({
          value: item.id,
          label: item.name,
        })) || [];
      const nearbyAmenitiesMapped =
        data.amenities?.[0]?.nearByAmenities?.map((item) => ({
          value: item.id,
          label: item.name,
        })) || [];

      setFormData((prev) => ({
        ...prev,
        propertyName: data.propertyName || prev.propertyName,
        propertyOverview: {
          ...prev.propertyOverview,
          name: data.propertyName || prev.propertyOverview.name,
          overallArea: data.overAllSqft || 0,
          availableUnits: data.availableUnitsCount || 0,
          launchDate: formatDateForInput(data.launchDate) || "",
          constructionType: data?.constructionType || "",
          averagePrice: {
            min: data.minAvailableBudget || 0,
            max: data.maxAvailableBudget || 0,
          },
          averageUnitSqft: {
            min: data.minAvailableSqft || 0,
            max: data.maxAvailableSqft || 0,
          },
          configuration: data.configuration || "",
          possessionStatus: data.possessionStatus || "",
          basicAmenities:
            data.amenities?.[0]?.basicAmenities?.map((item) => ({
              id: item.id,
              name: item.name,
            })) || [],
          featuredAmenities:
            data.amenities?.[0]?.futureAmenities?.map((item) => ({
              id: item.id,
              name: item.name,
            })) || [],
          nearbyAmenities:
            data.amenities?.[0]?.nearByAmenities?.map((item) => ({
              id: item.id,
              name: item.name,
            })) || [],
        },
      }));

      setSelectedBasic(basicAmenitiesMapped);
      setSelectedFeatures(featuredAmenitiesMapped);
      setSelectedNearby(nearbyAmenitiesMapped);
    } catch (error) {
      console.error("Error fetching property overview:", error);
      showErrorToast("Failed to fetch property overview data.");
    }
  };

  useEffect(() => {
    if (!isEditMode) {
      if (selectedPropertyId && selectedPropertyTypeName) {
        getPropertyOverViewDetails();
      }
    }
  }, [selectedPropertyId, selectedPropertyTypeName]);

  useEffect(() => {
    const fetchAmenities = async () => {
      try {
        const response = await AmenitiesService.getAmentities();
        const data = response.data || [];

        setBasicAmenities(
          data
            .filter((item) => item.type === 1)
            .map((item) => ({ value: item.id, label: item.name }))
        );
        setFeaturesAmenities(
          data
            .filter((item) => item.type === 2)
            .map((item) => ({ value: item.id, label: item.name }))
        );
        setNearbyAmenities(
          data
            .filter((item) => item.type === 3)
            .map((item) => ({ value: item.id, label: item.name }))
        );
      } catch (error) {
        console.error("Error fetching amenities data:", error);
       // showErrorToast("Failed to fetch amenities data.");
      }
    };
    fetchAmenities();
  }, []);

  const handleClosePopup = useCallback(
    ({
      selectedStyleDetails,
      selectedProperty,
      selectedPropertyId,
      selectedPropertyTypeId,
    } = {}) => {
      setFormData((prevState) => ({
        ...prevState,
        pageStyle: {
          label: selectedStyleDetails?.label || prevState.pageStyle.label,
          color: selectedStyleDetails?.color || prevState.pageStyle.color,
        },
        propertyName: selectedProperty || prevState.propertyName,
        propertyId: selectedPropertyId || prevState.propertyId,
        propertyType: selectedPropertyTypeId || prevState.propertyType,
      }));
      setOpenPopup(false);
    },
    []
  );

  const validateCurrentStep = () => {
    const phoneRegex = /^[0-9]{10}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
    switch (currentStep) {
      case 1:
        if (!formData.header?.logo) {
          showErrorToast("Logo is required.");
          return false;
        }
        if (!formData.hero?.title) {
          showErrorToast("Hero Title is required.");
          return false;
        }
        if (!formData.hero?.description) {
          showErrorToast("Hero Description is required.");
          return false;
        }
        if (!formData.hero?.bannerImages?.length) {
          showErrorToast("Hero Banner Images are required.");
          return false;
        }
        if (!formData.header?.phoneNumber) {
          showErrorToast("Phone Number is required.");
          return false;
        }
        if (!phoneRegex.test(formData.header?.phoneNumber)) {
          showErrorToast("Please enter a valid 10-digit phone number.");
          return false;
        }
        return true;
  
      case 2: 
        if (formData.featuresSection?.enable) {
          if (!formData.featuresSection.title.trim()) {
            showErrorToast("Features section title is required.");
            return false;
          }
  
          const sections = [
            formData.featuresSection.section1,
            formData.featuresSection.section2,
            formData.featuresSection.section3,
            formData.featuresSection.section4,
            formData.featuresSection.section5,
          ];
  
          for (let i = 0; i < sections.length; i++) {
            if (!sections[i].title || !sections[i].image) {
              showErrorToast(`Section ${i + 1} title and image are required.`);
              return false;
            }
          }
        }
        return true;

        case 3: 
        if (formData.propertyOverview?.enable) {
           if (!formData.propertyOverview.description.trim()) {
            showErrorToast("Property Overview description is required.");
            return false;
           }
           
        }
        return true;


  
      case 4: 
        if (formData.formData?.enable) {
          const { title, description, image, field1, field2, field3, field4 } = formData.formData;
  
          if (!title.trim()) {
            showErrorToast("Form section title is required.");
            return false;
          }
          if (!description.trim()) {
            showErrorToast("Form section description is required.");
            return false;
          }
          if (!image.trim()) {
            showErrorToast("Form section image is required.");
            return false;
          }
  
          const fields = [field1, field2, field3, field4];
          for (let i = 0; i < fields.length; i++) {
            if (!fields[i].name.trim()) {
              showErrorToast(`Field ${i + 1} name is required.`);
              return false;
            }
          }
        }
        return true;
  
      case 5:
        if (formData.gallery?.enable) {
          if (!formData.gallery.title.trim()) {
            showErrorToast("Gallery title is required.");
            return false;
          }
          if (!formData.gallery.images?.length) {
            showErrorToast("At least one gallery image is required.");
            return false;
          }
        }
        return true;
  
     
      case 6:
        if (formData.contactUs?.enable) {
          const map = formData.contactUs?.map;
  
          if (!formData.contactUs.title.trim()) {
            showErrorToast("Contact section title is required.");
            return false;
          }
          // if (!map.location.trim()) {
          //   showErrorToast("Map location is required.");
          //   return false;
          // }
          if (!map.address.trim()) {
            showErrorToast("Map address is required.");
            return false;
          }
          if (map.phoneNumber && !phoneRegex.test(map.phoneNumber)) {
            showErrorToast("Please enter a valid 10-digit contact phone number.");
            return false;
          }
          if (map.email && !emailRegex.test(map.email)) {
            showErrorToast("Please enter a valid email address.");
            return false;
          }
        }
        return true;
  
      case 7: 
        if (formData.customerTestimonial?.enable) {
          const { customer1, customer2, customer3 } = formData.customerTestimonial;
  
          const isComplete = (testimonial) =>
            testimonial.name.trim() !== "" && testimonial.feedback.trim() !== "";
  
          if (!isComplete(customer1)) {
            showErrorToast("Customer 1 testimonial name and feedback are required.");
            return false;
          }
  
          if (!isComplete(customer2)) {
            showErrorToast("Customer 2 testimonial name and feedback are required.");
            return false;
          }
  
          if (!isComplete(customer3)) {
            showErrorToast("Customer 3 testimonial name and feedback are required.");
            return false;
          }
        }
        return true;

        case 8: 
        if (formData.videoSection?.enable) {
          if (!formData.videoSection.title.trim()) {
            showErrorToast("Video title is required.");
            return false;
          }
          if (!formData.videoSection.description.trim()) {
            showErrorToast("Video description is required.");
            return false;
          }
          if (!formData.videoSection.videoLink.trim()) {
            showErrorToast("Video link is required.");
            return false;
          }
        }
        return true;
  
  
      default:
        return true;
    }
  };
  

  const handleSubmit = async () => {
    if (!validateCurrentStep()) return;
    
    if (currentStep < steps.length) {
      handleNext();
      return;
    }
    setLoading(true)
    
    const dataToSend = {
      pageStyle: formData.pageStyle,
      propertyId: formData.propertyId,
      propertyType: formData.propertyType,
      header: formData.header,
      hero: formData.hero,
      featuresSection: formData.featuresSection,
      formData: formData.formData,
      gallery: formData.gallery,
      contactUs: formData.contactUs,
      customerTestimonial: formData.customerTestimonial,
      videoSection: formData.videoSection,
      footer: formData.footer,
      propertyOverview: formData.propertyOverview,
    };

    try {
      if (GLPageId) {
        await GLPagesService.UpdateGLPage(GLPageId, dataToSend);
        showSuccessToast("Page updated successfully!");
      } else {
        await GLPagesService.CreateGLPage(dataToSend);
        showSuccessToast("Page created successfully!");
      }
     
        navigate(-1);
    
      
    } catch (error) {
      console.error("Error saving GL page:", error.message);
      showErrorToast(
        error.response?.data?.message || "Failed to save GL page."
      );
    }finally{
      setLoading(false)
    }
  };

  const getGLPageInfoData = async () => {
    if (!GLPageId) return;
    try {
      const response = await GLPagesService.GetGLPageInfo(GLPageId);
      const data = response.data;

      console.log("GL page info:", response?.property);
      setFormData((prev) => ({
        ...prev,
        ...data,
        propertyName: response?.property?.name || prev.propertyName,
        propertyId: response?.property?.id || prev.propertyId,
        propertyType: response.propertyType || prev.propertyType,
        propertyOverview: {
          ...prev.propertyOverview,
          ...data.propertyOverview,
          name: data.propertyOverview?.name || prev.propertyOverview.name,
        },
      }));
      if (data.propertyOverview) {
        setSelectedBasic(
          data.propertyOverview.basicAmenities?.map((item) => ({
            value: item.id,
            label: item.name,
          })) || []
        );
        setSelectedFeatures(
          data.propertyOverview.featuredAmenities?.map((item) => ({
            value: item.id,
            label: item.name,
          })) || []
        );
        setSelectedNearby(
          data.propertyOverview.nearbyAmenities?.map((item) => ({
            value: item.id,
            label: item.name,
          })) || []
        );
      }
    } catch (error) {
      console.error("Error getting GL Page Info:", error.message);
      showErrorToast(
        error.response?.data?.message || "Failed to fetch GL page info."
      );
    }
  };

  useEffect(() => {
    if (GLPageId) {
      getGLPageInfoData();
    }
  }, [GLPageId]);

  const handleImageChange = async (e, type) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = [
      "image/png",
      "image/svg+xml",
      "image/webp",
      "image/jpeg",
      "image/jpg",
    ];
    if (!allowedTypes.includes(file.type)) {
      showErrorToast("Only PNG, SVG, WebP, JPG or JPEG images are allowed.");
      e.target.value = null;
      return;
    }

    if (file.size > 1024 * 1024) {
      showInfoToast("Image size must be less than 1MB.");
      e.target.value = null;
      return;
    }

    if (!sizeGuide) {
      showInfoToast("Please select a valid style template first.");
      return;
    }

    const sizeText =
      type === "logo"
        ? sizeGuide.logo
        : type === "bannerImages"
        ? sizeGuide.heroBannerSize
        : type === "sectionForm"
        ? sizeGuide.formImage
        : type === "sectionMore"
        ? sizeGuide.moreImages
        : sizeGuide.featuresSectionImage;

    const [requiredWidth, requiredHeight] = sizeText
      .split("x")
      .map((n) => parseInt(n.trim()));

    const img = new Image();
    const objectUrl = URL.createObjectURL(file);
    img.src = objectUrl;

    img.onload = async () => {
      const { width, height } = img;
      URL.revokeObjectURL(objectUrl);

      const tolerance = 20;
      const isWidthInRange =
        width >= requiredWidth - tolerance &&
        width <= requiredWidth + tolerance;
      const isHeightInRange =
        height >= requiredHeight - tolerance &&
        height <= requiredHeight + tolerance;

      if (!isWidthInRange || !isHeightInRange) {
        showInfoToast(
          `Please upload an image close to ${requiredWidth}x${requiredHeight}px for "${type}" (${selectedLabel}). Allowed tolerance is ±${tolerance}px.`
        );
        e.target.value = null;
      }

      setLoadingState((prev) => ({ ...prev, [type]: true }));

      try {
        const uploadFormData = new FormData();
        uploadFormData.append("file", file);
        const folderPath = "GLpage";
        const response = await SpinWheelService.createBannerImageTemplate(
          uploadFormData,
          folderPath
        );

        setFormData((prev) => {
          if (type === "logo") {
            return {
              ...prev,
              header: { ...prev.header, logo: response.data.imageUrl },
            };
          } else if (
            [
              "section1",
              "section2",
              "section3",
              "section4",
              "section5",
            ].includes(type)
          ) {
            return {
              ...prev,
              featuresSection: {
                ...prev.featuresSection,
                [type]: {
                  ...prev.featuresSection[type],
                  image: response.data.imageUrl,
                },
              },
            };
          } else if (type === "bannerImages") {
            return {
              ...prev,
              hero: {
                ...prev.hero,
                bannerImages: [
                  ...prev.hero.bannerImages,
                  response.data.imageUrl,
                ],
              },
            };
          } else if (type === "sectionMore") {
            return {
              ...prev,
              gallery: {
                ...prev.gallery,
                images: [...prev.gallery.images, response.data.imageUrl],
              },
            };
          } else if (type === "sectionForm") {
            return {
              ...prev,
              formData: {
                ...prev.formData,
                image: response.data.imageUrl,
              },
            };
          }
          return prev;
        });
      } catch (error) {
        console.error("Error uploading image:", error.response?.data);
        showErrorToast("Failed to upload image.");
      } finally {
        setLoadingState((prev) => ({ ...prev, [type]: false }));
      }
    };
  };

  const handelDeleteImages = async (imageUrl, type) => {
    try {
      await GLPagesService.DeleteGLPageImage(imageUrl);
      setFormData((prev) => {
        if (type === "logo") {
          return { ...prev, header: { ...prev.header, logo: null } };
        } else if (type === "bannerImages") {
          return {
            ...prev,
            hero: {
              ...prev.hero,
              bannerImages: prev.hero.bannerImages.filter(
                (img) => img !== imageUrl
              ),
            },
          };
        } else if (type === "sectionMore") {
          return {
            ...prev,
            gallery: {
              ...prev.gallery,
              images: prev.gallery.images.filter((img) => img !== imageUrl),
            },
          };
        } else if (
          ["section1", "section2", "section3", "section4", "section5"].includes(
            type
          )
        ) {
          return {
            ...prev,
            featuresSection: {
              ...prev.featuresSection,
              [type]: { ...prev.featuresSection[type], image: null },
            },
          };
        } else if (type === "sectionForm") {
          return {
            ...prev,
            formData: { ...prev.formData, image: null },
          };
        }
        return prev;
      });
    } catch (error) {
      console.error(
        "Error deleting image:",
        error.response?.data || error.message
      );
      showErrorToast("Failed to delete image.");
    }
  };

  const handlePreviewClick = () => {
    setShowPreview(!showPreview);
  };

  const handleNext = () => {
    if(!validateCurrentStep()) {
      return
    }
    
    if (currentStep < steps.length) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handlePrevious = () => {
    if(!validateCurrentStep()) {
      return
    }
   
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleStepClick = (stepNumber) => {
    if(!validateCurrentStep()) {
      return
    }else{
      setCurrentStep(stepNumber);
    }
    
  };
  

  return (
    <div className="bg-appGrayBackground min-h-screen pt-20">
      <ToastContainer />
      <AdminAppBar />
      <div className="px-6 mt-7">
        <div className="flex flex-col">
          <div className="flex justify-between items-center">
            <CustomHeading
              title={`${GLPageId ? "Edit" : "New"} GL Page`}
              isIcon={true}
            />
            <div className="flex gap-3">
              {GLPageId && (
                <button
                  onClick={handlePreviewClick}
                  className=" bg-emerald-600 cursor-pointer text-white px-6 py-2 rounded-[10px]"
                >
                  {showPreview ? "Hide Preview" : "Show Preview"}
                </button>
              )}

<button
            onClick={handlePrevious}
            disabled={currentStep === 1}
            className={`flex items-center gap-2 px-6 py-2 rounded-[10px] ${
              currentStep === 1
                ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                : "bg-gray-200 hover:bg-gray-300 text-gray-700 transition-colors"
            }`}
          >
            <FaChevronLeft />
            Previous
          </button>
          
          <button
            onClick={currentStep === steps.length ? handleSubmit : handleNext}
            disabled={loading}
            className={`flex items-center gap-2 px-6 py-2 rounded-[10px] ${
              currentStep === steps.length
                ? "bg-customGreen text-white"
                : "bg-customGreen  text-white"
            } transition-colors`}
          >
            {currentStep === steps.length ? (GLPageId ? "Update" : "Create") : "Next"}
            {currentStep < steps.length && <FaChevronRight />}
          </button>
              {/* <button
                onClick={handleSubmit}
                className=" w-36 bg-emerald-600 cursor-pointer text-white py-2 rounded"
              >
                {GLPageId ? "Update" : "Next"}
              </button> */}
            </div>
          </div>
          {showPreview && (
            <div className="mt-[30px]">
              <iframe
                src={`${glPageUrl}/gl-page/${GLPageId}`}
                width="100%"
                height="600px"
                title="Preview"
                frameBorder="0"
              />
            </div>
          )}
          <div className="flex p-3 mt-[30px] bg-white max-w-fit gap-4 items-center rounded-lg">
            <div className="flex items-center text-nowrap gap-2">
              <div>Property:</div>
              <div className="text-xl font-bold">{formData.propertyName}</div>
            </div>
            <div className="flex items-center gap-2 text-nowrap">
              <div>Page Style:</div>
              <div className={`text-xl font-bold ${formData.pageStyle.color}`}>
                {formData.pageStyle.label}
              </div>
              <FiEdit
                onClick={() => setOpenPopup(true)}
                className="cursor-pointer text-lg hover:text-emerald-600"
              />
            </div>
          </div>
        </div>

        <div className="w-full bg-white p-[17px] rounded-md mt-[30px]">
          
            <div className={`flex items-center justify-center  mt-2 ${""}`}>
      <div className="flex items-center justify-between w-full relative">
        {steps.map((step, index) => (
          <div
            key={step.id || index}
             onClick={() => handleStepClick(index + 1)}
            className="flex cursor-pointer flex-col items-center z-10 w-1/3"
            role="button"
            tabIndex={0}
            // onKeyDown={(e) => e.key === 'Enter' && handleStepClick(index + 1)}
            aria-label={`Step ${index + 1}: ${step.label}`}
          >
            <div
              className={`w-8 h-8 border-2 rounded-full flex items-center justify-center font-bold mb-2 transition-all duration-500 ease-in-out transform ${
                currentStep > index
                  ? 'bg-white border-customGreen'
                  : 'bg-gray-300 border-gray-300'
              } ${currentStep === index + 1 ? 'scale-110' : ''}`}
            >
              <div
                className={`h-6 w-6 rounded-full flex items-center justify-center text-[16px] transition-all duration-500 ${
                  currentStep > index
                    ? 'bg-customGreen text-white'
                    : 'bg-gray-300 text-gray-700'
                }`}
              >
                {currentStep > index ? (
                  <span className="animate-fadeIn">✓</span>
                ) : (
                  <div className='bg-white w-6 h-6 rounded-full'></div>
                )}
              </div>
            </div>
            <span
              className={`text-[11px] font-medium text-center transition-all duration-300 ${
                currentStep === index + 1 ? 'text-customGreen' : 'text-gray-700'
              }`}
            >
              {step.label}
            </span>
          </div>
        ))}

        {/* Connector with animation */}
        <div className="absolute top-4  left-[60px]   w-[90%] h-0.5 bg-gray-300 z-0">
          <div
            className="h-0.5 bg-customGreen transition-all duration-500 ease-in-out"
            style={{
              width: `${((currentStep - 1) / (steps.length - 1)) * 100}%`,
            }}
          />
        </div>
      </div>
    </div>
        </div>
        <div className=" rounded-md  mt-5">
          {currentStep === 1 && (
            <HeaderAndHero
              formData={formData}
              setFormData={setFormData}
              loadingState={loadingState}
              sizeGuide={sizeGuide}
              sampleGuide={sampleGuide}
              handleImageChange={handleImageChange}
              handelDeleteImages={handelDeleteImages}
            />
          )}

          {currentStep === 2 && (
            <FeaturesSection
              formData={formData}
              setFormData={setFormData}
              loadingState={loadingState}
              sizeGuide={sizeGuide}
              sampleGuide={sampleGuide}
              handleImageChange={handleImageChange}
              handelDeleteImages={handelDeleteImages}
            />
          )}

          {currentStep === 3 && (
            <PropertyOverview
              formData={formData}
              setFormData={setFormData}
              addSelectAllOption={addSelectAllOption}
              basicAmenities={basicAmenities}
              featuresAmenities={featuresAmenities}
              nearbyAmenities={nearbyAmenities}
              selectedBasic={selectedBasic}
              selectedFeatures={selectedFeatures}
              selectedNearby={selectedNearby}
              handleSelectChange={handleSelectChange}
              sampleGuide={sampleGuide}
            />
          )}
          {currentStep === 4 && (
            <FormSection
              formData={formData}
              setFormData={setFormData}
              sizeGuide={sizeGuide}
              sampleGuide={sampleGuide}
              loadingState={loadingState}
              handleImageChange={handleImageChange}
              handelDeleteImages={handelDeleteImages}
            />
          )}
          {currentStep === 5 && (
            <MoreImages
              formData={formData}
              setFormData={setFormData}
              sizeGuide={sizeGuide}
              sampleGuide={sampleGuide}
              loadingState={loadingState}
              handleImageChange={handleImageChange}
              handelDeleteImages={handelDeleteImages}
            />
          )}
          {currentStep === 6 && (
            <ContactUs
              formData={formData}
              setFormData={setFormData}
              sampleGuide={sampleGuide}
            />
          )}
          {currentStep === 7 && (
            <CustomerTestimonial
              formData={formData}
              setFormData={setFormData}
              sampleGuide={sampleGuide}
            />
          )}
          {currentStep === 8 && (
            <VideoSection
              formData={formData}
              setFormData={setFormData}
              sampleGuide={sampleGuide}
              setVideoWarning={setVideoWarning}
              videoWarning={videoWarning}
            />
          )}
          {currentStep === 9 && (
            <FooterSection
              formData={formData}
              setFormData={setFormData}
              sampleGuide={sampleGuide}
            />
          )}

       
        </div>

        
        <div></div>
        
      </div>

       {/* Navigation buttons */}
       <div className="flex justify-between pb-20 px-6 mb-10 mt-6">
          <button
            onClick={handlePrevious}
            disabled={currentStep === 1}
            className={`flex items-center gap-2 px-6 py-2 rounded-md ${
              currentStep === 1
                ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                : "bg-gray-200 hover:bg-gray-300 text-gray-700 transition-colors"
            }`}
          >
            <FaChevronLeft />
            Previous
          </button>
          
          <button
            onClick={currentStep === steps.length ? handleSubmit : handleNext}
            className={`flex items-center gap-2 px-6 py-2 rounded-md ${
              currentStep === steps.length
                ? "bg-customGreen text-white"
                : "bg-customGreen  text-white"
            } transition-colors`}
          >
            {currentStep === steps.length ? (GLPageId ? "Update" : "Create") : "Next"}
            {currentStep < steps.length && <FaChevronRight />}
          </button>
        </div>
    
      

      {openPopup && (
        <GLpageTemplatePopup
          ClosePopup={handleClosePopup}
          GLPageId={GLPageId}
          initialPropertyType={formData.propertyType || "Villa"}
          initialPropertyTypeValue={formData.propertyTypeName || "1"}
          initialProperty={formData.propertyName}
          initialStyle={formData.pageStyle}
          initialPropertyId={formData.propertyId}
        />
      )}
    </div>
  );
};

export default GLpageCreatingSection;
